module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/images/pattern.a72becb8.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/images/pattern.png
// module id = 2545
// module chunks = 11